<div class="news__type--{{ type }}">
  <ng-container *ngIf="showTitle">
    <header class="header-noticia">
      <h1 class="titulo-noticia" #tituloNoticia>
        {{ noticia?.tituloVideo }}
      </h1>
      <h2 class="entradilla-noticia" #entradillaNoticia [innerHTML]="noticia?.entradillaVideo"></h2>
    </header>
  </ng-container>
  <div class="img-noticia">
    <ng-container *ngIf="!noticia?.portada_iframe_url && !(noticia?.portada_iframe === '1') && !showDivVideoArriba">
      <app-full-image-viewer [show]="showFlag" (close)="closeEventHandler()" (closeVideo)="scrollToDiv('divVideo', noticia?.urlVideo)" [urlVideo]="noticia?.urlVideo" [noticia]="noticia"> </app-full-image-viewer>
      <div class="client-feedback">
        <ng-container *ngIf="imagenes_relacionadas?.length > 1">
          <app-slider [noticia]="noticia" [images]="imagenes_relacionadas" [innerHeader]="innerHeader" [headerType]="type" (onLightBox)="showLightbox($event)" [currentIndex]="currentIndex"> </app-slider>
        </ng-container>
        <ng-container *ngIf="imagenes_relacionadas?.length === 1">
          <ng-container *ngIf="noticia?.urlVideo">
            <app-video-noticia #videoComponent [noticia]="noticia"></app-video-noticia>
          </ng-container>
          <ng-container *ngIf="!noticia?.urlVideo">
            <app-skeleton-image [created]="noticia?.fechaCreacion" [size]="970" [src]="imagenes_relacionadas[0]" [aspectRatio]="97 / 55" [lazy]="false" [alt]="noticia?.tituloVideo" width="100%" height="100%" (click)="showLightbox(0)"> </app-skeleton-image>
          </ng-container>
        </ng-container>
      </div>
      <div class="pie-img-noticia">
        <ng-container *ngIf="noticia?.pie_foto">
          {{ noticia.pie_foto }}
        </ng-container>
        <ng-container *ngIf="noticia?.nombre_fotografo?.length > 0">
          <span class="pie-img-noticia">
            | Foto: {{ noticia?.nombre_fotografo | titlecase }}
            <ng-container *ngIf="noticia?.nombre_agencia?.length > 0">
              <span> ({{ noticia?.nombre_agencia | titlecase }})</span>
            </ng-container>
          </span>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="showDivVideoArriba">
      <app-video-noticia [noticia]="noticia"></app-video-noticia>
    </ng-container>

    <ng-container *ngIf="noticia?.portada_iframe_url && noticia?.portada_iframe === '1' && !showDivVideoArriba">
      <iframe [src]="noticia?.portada_iframe_url | safeResourceUrl" width="100%" height="370"></iframe>
    </ng-container>
  </div>
</div>
